import type { UserRole } from "./user-role.type";
import type { Int } from "@/types";

import {
  USER_DEFAULT_PRIORITY,
  USER_ROLE_REFERENTIAL,
} from "./user-role.constant";

export const isOrganizationRole = ({
  role,
  organizationId,
}: {
  role: UserRole;
  organizationId: Int;
}) => {
  const organizationModelPath = "App\\Models\\Organization";

  return (
    !role.subject_type ||
    (role.subject_type === organizationModelPath &&
      role.subject_id === organizationId)
  );
};

export const sortRoleByPriority = (roleA: UserRole, roleB: UserRole) => {
  const aPriority = getUserRolePriority(roleA);
  const bPriority = getUserRolePriority(roleB);

  return aPriority - bPriority;
};

export const getUserRolePriority = (role: UserRole) => {
  return (
    USER_ROLE_REFERENTIAL.find((r) => role.name.includes(r.name))?.priority ??
    USER_DEFAULT_PRIORITY
  );
};

export const getOrganizationMainRoles = ({
  roles,
  organizationId,
}: {
  roles?: UserRole[];
  organizationId: Int;
}) =>
  (roles ?? [])
    .filter((role) => isOrganizationRole({ role, organizationId }))
    .sort(sortRoleByPriority);
